import { Link } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";

const AboutPage = () => {
  useSEO({
    title: "About TaxShift 2026 — Independent OBBBA Tax Analysis",
    description: "TaxShift 2026 is an independent editorial calculator suite explaining how OBBBA (Public Law 119-21) reshaped federal taxation for 2026 and beyond.",
    path: "/about",
  });

  return (
    <div className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="font-mono uppercase text-[10px] tracking-[0.3em] text-muted-foreground mb-4 block">
          About
        </span>
        <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-tight mb-8" data-testid="about-title">
          Independent. <span className="italic">Editorial.</span> Free.
        </h1>
        <div className="space-y-5 font-body text-lg leading-relaxed text-foreground/85">
          <p>
            TaxShift 2026 is an independent web publication dedicated to one question: what does the
            One Big Beautiful Bill Act (OBBBA, Public Law 119-21, signed July 4, 2025) mean for
            American households, small businesses, and estates in 2026 and beyond?
          </p>
          <p>
            We built a suite of eleven calculators — covering federal brackets, the standard
            deduction, child tax credit, capital gains, SALT, QBI, estate tax, plus OBBBA's brand-new
            deductions for tips, overtime, seniors, and auto loan interest. Every number is based on
            actual IRS Revenue Procedures and enacted statutory text.
          </p>
          <p>
            We're supported by contextual Google AdSense advertising — no paywalls, no email-gated
            calculators, no upsells. Our editorial voice is independent and does not accept
            sponsored content from tax-advice firms.
          </p>
          <h2 className="font-heading text-3xl font-semibold mt-10 tracking-tight">Our sources</h2>
          <p>
            Statutory figures are drawn from Public Law 119-21 (OBBBA), IRS Revenue Procedures
            (2024-40 for 2025 figures, 2025-32 for 2026), Congressional Budget Office analyses,
            and peer-reviewed tax policy research. Where figures are estimates (e.g., certain
            phase-out boundaries still pending final Treasury regulations), we note the source and
            our assumptions.
          </p>
          <h2 className="font-heading text-3xl font-semibold mt-10 tracking-tight">Important disclaimer</h2>
          <p>
            TaxShift 2026 publishes educational analysis and illustrative calculators. We are not a
            tax-advisory firm, law firm, or financial planner. Always consult a qualified tax
            professional before making material financial decisions. See our{" "}
            <Link to="/disclaimer" className="underline text-primary">Disclaimer</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
